import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { HelpCentrePage, type HelpCentreTab } from '@/features/help-centre/HelpCentrePage';
import i18n from '@/lib/i18n';

const searchSchema = z.object({
  q: z.string().optional().default(''),
  tab: z.enum(['home', 'articles', 'chat', 'contact']).optional().default('home'),
});

export const Route = createFileRoute('/_authenticated/help-centre')({
  validateSearch: searchSchema,
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.helpCentre'),
  }),
  component: HelpCentreRoute,
});

function HelpCentreRoute() {
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  const updateSearch = (updates: Partial<{ q: string; tab: HelpCentreTab }>) => {
    void navigate({
      search: (prev) => ({
        ...prev,
        ...updates,
      }),
      replace: true,
    });
  };

  return (
    <HelpCentrePage
      query={search.q}
      tab={search.tab}
      onQueryChange={(query, nextTab) => updateSearch({ q: query, tab: nextTab ?? 'articles' })}
      onTabChange={(tab) => updateSearch({ tab })}
    />
  );
}
